import { render, staticRenderFns } from "./CommandDeliveryPlugin.vue?vue&type=template&id=63c1d72b&"
import script from "./CommandDeliveryPlugin.vue?vue&type=script&lang=ts&"
export * from "./CommandDeliveryPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports